module.exports = __webpack_public_path__ + "./sound/alert-add-item.f259b1da37002c0e11c94e71be3d0b2b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/alert-add-item.mp3
// module id = ./src/sound/alert-add-item.mp3
// module chunks = 0